<!-- 由 Dioa 创建于 2022-08-25 星期四 -->
<template>
  <div class="user-tag">
    <div class="selected-tag-wrapper">
      <div class="selected-tag-top">
        <img
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-person-tag"
          alt=""
          class="selected-tag-icon"
        />
        <div class="selected-tag-title">已选标签</div>
        <div class="selected-tag-tip">
          已选择{{ tagList.length }}个标签，还可选择{{ 20 - tagList.length }}个
        </div>
      </div>

      <div class="selected-tag-bottom">
        <template v-if="tagList && tagList.length">
          <div
            :class="fTagColor(item.attr)"
            class="tag-item"
            v-for="(item, index) in tagList"
            :key="index"
          >
            <span>{{ item.tag_name }}</span>
            <img
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-tag-close"
              alt=""
              @click="onCloseTag(item)"
            />
          </div>
        </template>

        <template v-else>
          <div class="no-data">暂无标签</div>
        </template>
      </div>
    </div>

    <div class="optional-tag-wrapper">
      <div class="optional-tag-top">
        <img
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-selected-tag-icon"
          alt=""
          class="optional-tag-icon"
        />
        <div class="optional-tag-title">可选标签</div>
        <span class="iconfont icon-help" @click="openTipModal"></span>
      </div>

      <div class="optional-bottom-wrapper">
        <div class="optional-bottom-title">人工标签</div>

        <div class="artificial-tags" :class="{ collapse: isTopCollapse }">
          <div
            class="tag-item"
            :class="{
              'disable-tag': tagList.map((item) => item.id).includes(item.id)
            }"
            @click="onTagClick(item)"
            v-for="(item, index) in artificialTags"
            :key="index"
            >{{ item.tag_name }}</div
          >
        </div>

        <div class="collapse-wrapper" @click="isTopCollapse = !isTopCollapse">
          <template v-if="isTopCollapse">
            <span>展开</span>
            <van-icon name="arrow-down" />
          </template>

          <template v-else>
            <span>收起</span>
            <van-icon name="arrow-up" />
          </template>
        </div>

        <div class="optional-bottom-title">问卷标签</div>

        <div class="questionnaire-tags" :class="{ collapse: isBottomCollapse }">
          <div
            class="tag-item"
            :class="{
              'disable-tag': tagList.map((item) => item.id).includes(item.id)
            }"
            @click="onTagClick(item)"
            v-for="(item, index) in questionnaireTags"
            :key="index"
            >{{ item.tag_name }}</div
          >
        </div>

        <div
          class="collapse-wrapper"
          @click="isBottomCollapse = !isBottomCollapse"
          style="margin-bottom: 0"
        >
          <template v-if="isBottomCollapse">
            <span>展开</span>
            <van-icon name="arrow-down" />
          </template>

          <template v-else>
            <span>收起</span>
            <van-icon name="arrow-up" />
          </template>
        </div>
      </div>
    </div>

    <div
      class="submit-btn"
      :class="{ 'disabled-btn': !tagList.length }"
      @click="onSubmit"
      >完成</div
    >
  </div>
</template>

<script>
export default {
  name: 'user-tag',

  components: {},

  props: {},

  data() {
    return {
      tagList: [],
      questionnaireTags: [],
      artificialTags: [],
      unify_id: this.$route.query?.unify_id,
      isTopCollapse: true,
      isBottomCollapse: true
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.getAllData()
  },

  destroyed() {},

  methods: {
    // 获取所有tag
    getAllTags() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getBaseApp('member/UserTag/getTags')
        if (res?.data?.code == 200) {
          this.questionnaireTags = res?.data?.data.filter(
            (item) => item.type == 2
          )
          this.artificialTags = res?.data?.data.filter((item) => item.type == 1)
          resolve()
        }
      })
    },
    // 获取用户信息
    getUserTag() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getBaseApp('member/UserTag/getUserTag', {
          uid: this.unify_id
        })
        if (res?.data?.code == 200) {
          this.tagList = res?.data?.data
        }

        resolve()
      })
    },
    getAllData() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      Promise.all([this.getAllTags(), this.getUserTag()]).finally(() => {
        this.$toast.clear()
      })
    },
    // 提交标签
    async onSubmit() {
      if (!this.tagList.length) {
        return
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      let res = await this.$http.postBaseApp('member/UserTag/setUserTag', {
        tag_ids: this.tagList.map((item) => item.id),
        uid: this.unify_id
      })
      if (res?.data?.code == 200) {
        this.$toast.clear()
        this.$toast.success('设置成功!')
        setTimeout(() => {
          this.getAllData()
        }, 1000)
      } else {
        this.$toast.clear()
        this.$toast.fail('操作失败')
      }
    },
    fTagColor(type) {
      switch (type) {
        case 2: {
          return 'red'
        }
        case 1: {
          return 'green'
        }
        case 3: {
          return 'blue'
        }
      }
    },
    // 标签点击
    onTagClick(tag) {
      if (this.tagList.length >= 20) {
        this.$toast.fail('标签最多可选择20个')
        return
      }
      let isBoolean = this.tagList.map((item) => item.id).includes(tag.id)

      if (isBoolean) {
        return
      }

      this.tagList.push(tag)

      if (this.tagList.length >= 20) {
        this.$toast('标签数量已达到上限')
      }
    },
    // 标签删除
    onCloseTag(tag) {
      this.tagList = this.tagList.filter((item) => item.id != tag.id)
    },
    openTipModal() {
      this.$dialog.alert({
        message: `1. 问卷标签：根据学员填写过的入营问卷、CNA问卷等所有问卷中，提取出来的标签信息。 <br /> <br />2. 人工标签：营养师或售后根据服务过程中常出现的情况，人工定义的标签。<br /> <br />3. tips：*若需要新增标签选项，可联系标签管理负责人统一添加
        `,
        messageAlign: 'left',
        confirmButtonColor: '#6236ff'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.user-tag {
  text-align: left;
  padding: vw(20);
  min-height: 100vh;
  background-color: #fafafa;
  box-sizing: border-box;
  .selected-tag-wrapper {
    background-color: #fff;
    padding: vw(20) vw(15) vw(11);
    border-radius: vw(12);
    margin-bottom: vw(16);
    .selected-tag-top {
      display: flex;
      align-items: center;
      margin-bottom: vw(14);
      .selected-tag-icon {
        width: vw(18);
        margin-right: vw(4);
      }
      .selected-tag-title {
        font-size: vw(16);
        font-weight: 500;
        color: #000000;
        margin-right: vw(10);
      }
      .selected-tag-tip {
        font-size: vw(10);
        font-weight: 400;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .selected-tag-bottom {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .optional-tag-wrapper {
    background-color: #fff;
    padding: vw(20) vw(15) vw(11);
    border-radius: vw(12);
    margin-bottom: vw(90);
    .optional-tag-top {
      display: flex;
      align-items: center;
      margin-bottom: vw(14);
      .optional-tag-icon {
        width: vw(18);
        margin-right: vw(4);
      }
      .optional-tag-title {
        font-size: vw(16);
        font-weight: 500;
        color: #000000;
        margin-right: vw(4);
      }
      .iconfont {
        font-size: vw(18);
        color: rgba(#000, 0.6);
      }
    }

    .optional-bottom-wrapper {
      .optional-bottom-title {
        font-size: vw(14);
        font-weight: 500;
        color: #000000;
        margin-bottom: vw(9);
      }

      .collapse-wrapper {
        margin: vw(10) 0 vw(20);
        font-size: vw(12);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(#000, 0.5);
        span {
          margin-right: vw(5);
        }
      }

      .questionnaire-tags,
      .artificial-tags {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: vw(7);
        &.collapse {
          height: vw(160);
          overflow: hidden;
        }
      }
    }
  }

  .submit-btn {
    padding: vw(12) 0;
    background: #6236ff;
    border-radius: vw(10);
    font-size: vw(14);
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    &.disabled-btn {
      opacity: 0.3;
    }
  }

  .tag-item {
    padding: vw(7) vw(14);
    font-size: vw(12);
    font-weight: 400;
    color: #000000;
    border-radius: vw(15);
    border: 1px solid rgba(118, 118, 118, 0.1);
    margin-right: vw(8);
    margin-bottom: vw(9);
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    img {
      position: absolute;
      right: 0;
      top: 0;
      width: vw(12);
    }
    &.disable-tag {
      opacity: 0.3;
    }
    &.red {
      background: linear-gradient(#f9d5ff 0%, #ffe0e0 100%);
    }
    &.green {
      background: linear-gradient(#fffef8 0%, #eefff4 100%);
    }
    &.blue {
      background: linear-gradient(#faf8ff 0%, #eefbff 100%);
    }
  }

  .no-data {
    font-size: vw(14);
    text-align: center;
    color: rgba(#000, 0.5);
    margin: vw(10) 0;
  }
}
</style>
